<template>
    <div>
        <div class="row">
            <div class="col-auto">
                <b-form-select :options="fieldTemplates"></b-form-select>
            </div>
            <div class="col-auto">
                <button class="btn btn-success" @click.prevent="loadTemplate">Carica</button>
            </div>
            <div class="col"></div>
            <div class="col-auto align-self-end">
                <button class="btn btn-primary" @click.prevent="addField"><i class="fas fa-plus"></i></button>
            </div>
        </div>
        <hr/>
        <draggable v-model="value" handle=".handle">
            <dynamic-field
                v-for="(field, index) in value"
                :value="field"
                :key="index"
                @input="$emit('input', value)"
                @delete="remove(index)"
                @open="open(index)"
                :open="fieldOpened === index"
            ></dynamic-field>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import DynamicField from "./DynamicField";

export default {
    name: "FieldsTab",
    components: {
        DynamicField,
        draggable,
    },
    data() {
        return {
            fieldOpened: null,
        }
    },
    computed: {
        fieldTemplates() {
            return [
                { value: null, text: 'Seleziona un template' }
            ]
        }
    },
    props: {
        value: Array
    },
    methods: {
        remove(index) {
            let fields = this.value
            fields.splice(index, 1)
            this.value = fields
        },
        open(index) {
            if (this.fieldOpened === index) {
                this.fieldOpened = null
                return
            }

            this.fieldOpened = index
        },
        loadTemplate() {

        },
        addField() {
            let currentFields = this.value
            currentFields.push({ key: '', title: '', type: null })
            this.value = currentFields
            this.$emit('input', this.value)
        }
    }
}
</script>

<style scoped>

</style>
